import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import moment from 'moment/min/moment-with-locales';
import { debounce } from 'lodash';
import {useMediaQuery} from "react-responsive";
import {formatLocalDate, getLabel, resizeHandler, smallerImage} from '../../utils';
import FeaturedItemsHolder from './FeaturedItemsStyles';

import Video from '../Video/Video';

const FeaturedItems = (props) => {
	const [chgSize, setChgSize] = useState(false);
	const [showCPACTV, setShowCPACTV] = useState(true);

	// medium
	const is921_ = useMediaQuery({query: '(min-width: 921px)' })
	const isMd = useMediaQuery({query: '(min-width: 321px) and (max-width: 520px)'})
	// sm
	const is521_920 = useMediaQuery({query: '(min-width: 521px) and (max-width: 920px)'})
	const isSm = useMediaQuery({query: '(max-width: 320px)'})
	const imgSz = (is921_||isMd) ? "md" : (is521_920||isSm) ? "sm" : null;

	useEffect(()=>{
		resizeHandler('.featured-container__small-item');

		window.addEventListener('resize', debounce(function() {
			resizeHandler('.featured-container__small-item');
		},300));

		return ()=> window.removeEventListener('resize',()=>resizeHandler('.featured-container__small-item'));
	});

	useEffect(()=> {
		Moment.globalMoment = moment;

		if(props.current_lang === "en") {
			moment.locale("en");
			Moment.globalLocale = 'en';
		} else {
			moment.locale("fr");
			Moment.globalLocale = 'fr';
		}
	},[props.current_lang]);

	const renderSmallItemInfo = (item) => {
		const minutesBefore = process.env.REACT_APP_LIVE_NOTIFICATION_TIME;
		const now = new Date();
		const eventDateUTC = formatLocalDate(item.liveDateTime);
		const eventDateLocal = new Date(eventDateUTC);
		const eventSoonDate = moment(eventDateLocal).subtract(minutesBefore,"minutes").toDate();
		const isBetween = moment(now).isBetween(eventSoonDate,eventDateLocal , 'seconds', "[]");
		const alreadyStarted =  moment(now).isAfter(eventDateLocal)
		const calendarDay = moment(eventDateLocal).calendar(now);

		switch(item.type) {
			case "live":
				return (
					<>
						<div className="featured-container__small-item__info__header"> 
							<Link to={item.url} rel="noreferrer"><img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/></Link>
						</div>
						<div className="featured-container__small-item__info__description">
							<Link to={item.categoryURL} className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></Link> 
							<Link to={item.url} className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></Link>
						</div>
						{renderLive()}
					</>
				)
			case "prelive":
				if(isBetween === false) {
					if (alreadyStarted){
						return (
							<>
								<div className="featured-container__small-item__info__header"> 
									<Link to={item.url} rel="noreferrer"><img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/></Link>
								</div>
								<div className="featured-container__small-item__info__description">
									<Link to={item.categoryURL} className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></Link> 
									<Link to={item.url} className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></Link>
								</div>
								{renderLive()}
							</>
						)
					}
					else{
						return (
							<>
								<div className="featured-container__small-item__info__header"> 
									<img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/>
									<div className="featured-container__small-item__live-info">
										{calendarDay}
									</div>
								</div>
								<div className="featured-container__small-item__info__description">
									<p className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></p> 
									<p className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></p>
								</div>
							</>
						)
					}
				} else {
					return (
						<>
							<div className="featured-container__small-item__info__header"> 
								<Link to={item.url}><img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/></Link>
								<div className="featured-container__small-item__live-info">
									{getLabel("LIVE")}<Moment interval={1000} date={eventDateLocal} fromNow/>
								</div>
							</div>
							<div className="featured-container__small-item__info__description">
								<Link to={item.categoryURL} className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></Link> 
								<Link to={item.url} className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></Link>
							</div>
						</>
					)
				}
			case "cpactv":
				return (
					<>
						<div className="featured-container__small-item__info__header"> 
							<Link to={item.url}><img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/></Link>
						</div>
						<div className="featured-container__small-item__info__description">
							<Link to={item.categoryURL} className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></Link> 
							<Link to={item.url} className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></Link>
						</div>
						{renderCpactv()}
					</>
				)
			default:
				return (
					<>
						<div className="featured-container__small-item__info__header"> 
							<Link to={item.url}><img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image'/></Link>
						</div>
						<div className="featured-container__small-item__info__description">
							<Link to={item.categoryURL} className="featured-container__small-item__info__category"><span itemProp='subjectOf'>{item.category}</span></Link> 
							<Link to={item.url} className="featured-container__small-item__info__title"><span itemProp='name'>{item.title}</span></Link>
						</div>
					</>
				);
		}
	}

	const chgSizeHandler = curState => {
		setChgSize(curState);
	}

	const renderLive = () => {
		return (
			<div className="video-live-label t-l">
				<img src="/static-assets/theme/svg/target.svg" alt="target-icon"/>
				<span>{getLabel("LIVE")}</span>
			</div>
		)
	}

	const renderCpactv = index => {
		return showCPACTV && (
			<div className={`${index === 0  ? "featured-container__big-item__cpactv" : "featured-container__small-item__cpactv"}`}>
				<img src="/static-assets/theme/svg/left-decoration.svg" alt="left-decoration"/>
				<span>CPAC TV</span>
			</div>
		)
	}

	const renderItems = () => {
		return props.items.map((item,i) => {
			if(i === 0) {
				return (
					<div key={i} className={`featured-container__big-item ${chgSize ? "wide" : ""} ${props.items.length === 1 ? "only-item" : "" }` } itemProp='itemListElement'> 
						{item.type === "cpactv" ? renderCpactv(i) : <></>}
						{item.type === "live" ? renderLive() : <></>}
						<Video details={item} onChangeSize={(curState)=>chgSizeHandler(curState)} setShowCPACTV={setShowCPACTV} processPrelive={true} hOnlyItem={props.items.length === 1 ? true : false}/>
					</div>
				)
			} else {
				return (
					<div key={i} className="featured-container__small-item" tabIndex="0" itemProp='itemListElement'> 
						<div className="featured-container__small-item__info">
							{renderSmallItemInfo(item)}
						</div>
					</div>
				)
			}
		}); 
	}

	return (
		<FeaturedItemsHolder>
			<section className="featured-container" aria-label="featured-container" tabIndex="0" itemScope itemType='https://schema.org/ItemList'>
				{props.items && props.items.length > 0 && renderItems()}
			</section>
		</FeaturedItemsHolder>
	)
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

export default connect(mapStateToProps,null)(FeaturedItems);
